import { useSelector } from "react-redux";
import { selectCurrent as selectUserCurrent } from "../../../redux/user/selectors";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../hooks/hooks";
import { user } from "../../../redux/user/actions";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import useWindowDimensions from '../../../hooks/useWindowsDimensions';
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import storePersist from "../../../redux/storePersist";
import _ from "lodash";
import { rewardPoints } from "../../../redux/policy/merchandising/reward-points/action";
import AccountSettings from "../../../components/customer/AccountSettings";

export const RewardPoints = () => {
	const navigate = useNavigate()
	const dispatch = useAppDispatch();
	const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
	const { height, width } = useWindowDimensions();
	// const { theme } = useSelector(selectCurrent)
	const { isEditPersonalInfo } = useSelector(selectUserCurrent)
	const [color, setColor] = useState('universal')
	const [primary, setPrimary] = useState('#FFB934FF')
	const [secondary, setSecondary] = useState('#FFB934FF')
	const [menu, setMenu] = useState(false)
	const [open, setOpen] = useState([true, true, true, true, true])
	const [index, setIndex] = useState(0);
	const [steps, setSteps] = useState({})
	const [rewardPointsData, setRewardPointsData] = useState<any>({})
	const theme: any = 'lightmode'

	useEffect(() => {
		let slider = setInterval(() => {
			setIndex(index + 1);
		}, 3000);
		return () => clearInterval(slider);
	}, [index]);

	useEffect(() => {
		setColor(theme)
		if (theme == 'darkmode') {
			setPrimary('#f5e93cac')
			setSecondary('#ffffff')
		}
		else if (theme == 'lightmode') {
			setPrimary('#ffffffa2')
			setSecondary('#000000a2')
		}
		else if (theme == 'universal') {
			setPrimary('#233C64')
			setSecondary('#ffffff')
		}
		else if (theme == 'luxury') {
			setPrimary('#bd238c')
			setSecondary('#ffffff')
		}
		else if (theme == 'harmony') {
			setPrimary('#000000a2')
			setSecondary('#000000a2')
		}
		else if (theme == 'warmth') {
			setPrimary('#000000a2')
		}
	}, [theme]);

	const handleSave = () => {
		dispatch(user.set({ isEditPersonalInfo: false }))
	}

	useEffect(() => {
		getRewardPointsDetail();
	}, [])

	const getRewardPointsDetail = async () => {
		var userProfile = storePersist?.get("userProfile")?.current;
		var customerId = null;//userProfile?.items[0].Id;
		if (userProfile?.items?.length > 0) {
			const customer = _.find(userProfile.items[0]?.Message?.Roles, ['Name', "Logistics_Customer"]);
			console.log('customer', customer)
			customerId = customer?.Id;
		}

		var storeId = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization?.StoreId;
		const resp = await dispatch(rewardPoints.query({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/merchandising/reward-points/customer-balance`, entity: 'rewardPolicy', options: { notifyOnSuccess: false, notifyOnFailed: false }, jsonData:
			{
				"Records": [
					{
						"StoreId": storeId,
						"CustomerId": customerId
					}
				]
			}
		}));
		setRewardPointsData(resp?.items);
	}

	return (
		<>
			{width && width < 720 ?
				//  Start - Mobile View 
				<div className={`max-h-screen w-screen`}>
					<div className="w-full py-2">
						<div className="flex w-full flex-col items-center justify-center uppercase text-xl p-5 font-medium" >
							Reward Points
						</div>
						<div className="bg-white rounded-lg border-1 p-10">
							<dl className="grid max-w-screen-xl grid-cols-1 gap-16 mx-auto text-gray-900">
								<div className="flex flex-col items-center justify-center shadow-xl p-3">
									<dt className="mb-2 text-2xl text-secondary font-bold">{rewardPointsData?.PointsBalance || 0}</dt>
									<dd className="text-secondary text-xl font-semibold">Balance</dd>
								</div>
								<div className="flex flex-col items-center justify-center shadow-xl p-3">
									<dt className="mb-2 text-2xl text-secondary font-bold">{rewardPointsData?.PointsExpiringIn1Day || 0}</dt>
									<dd className="text-secondary text-xl font-semibold">Expiring Today</dd>
								</div>
								<div className="flex flex-col items-center justify-center shadow-xl p-3">
									<dt className="mb-2 text-2xl text-secondary font-bold">{rewardPointsData?.PointsExpiringIn7Days || 0}</dt>
									<dd className="text-secondary text-xl font-semibold">Expiring this week</dd>
								</div>
							</dl>
						</div>
					</div>
				</div >
				//  End - Mobile View  
				:
				//  Start - Web View  
				<div className="h-screen flex flex-col justify-between items-stretch bg-white">
					<div className="flex flex-row">
						<AccountSettings />
						<div className="w-3/4  justity-center items-center">
							<div className="w-full bg-white p-10">
								<div className="flex w-full flex-col items-start justify-between uppercase text-xl" >
									Reward Points
								</div>
								<div className="w-2/3 border-t border-gray-200 border border-gray-200 rounded-lg shadow py-10">
									<div className="p-4 bg-white rounded-lg md:p-8">
										<dl className="grid max-w-screen-xl grid-cols-2 gap-8 p-4 mx-auto text-gray-900 grid-cols-3">
											<div className="flex flex-col items-center justify-center">
												<dt className="mb-2 text-3xl font-extrabold">{rewardPointsData?.PointsBalance || 0}</dt>
												<dd className="text-gray-500 ">Balance</dd>
											</div>
											<div className="flex flex-col items-center justify-center">
												<dt className="mb-2 text-3xl font-extrabold">{rewardPointsData?.PointsExpiringIn1Day || 0}</dt>
												<dd className="text-gray-500 ">Expiring Today</dd>
											</div>
											<div className="flex flex-col items-center justify-center">
												<dt className="mb-2 text-3xl font-extrabold">{rewardPointsData?.PointsExpiringIn7Days || 0}</dt>
												<dd className="text-gray-500 ">Expiring this week</dd>
											</div>
										</dl>
									</div>

								</div>
							</div>
						</div>
					</div>

				</div>
				//  End - Web View 
			}
		</>
	)
}

